/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-group-overview.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloGroupOverviewTemplate from './silo-group-overview.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloGroupOverview', [])
    .directive('agSiloGroupOverview', SiloGroupOverview)
    .name;

/*@ngInject*/
function SiloGroupOverview() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            telemetryType: '<'
        },
        controller: SiloGroupOverviewController,
        controllerAs: 'vm',
        templateUrl: siloGroupOverviewTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloGroupOverviewController($scope, $filter, $q, $translate, unitService, types, agTypes, agUtils, siloGroupService, entityService, userService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloGroupId = null;
    vm.hasMoistureData = false;
    vm.hasCO2Data = false;

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [];
            vm.ctx.hideTitlePanel = false;

            vm.siloGroupId = null;
            if (vm.ctx.stateController) {
                vm.siloGroupId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSiloGroup();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloGroupId, prevSiloGroupId) {
                    if (newSiloGroupId && !angular.equals(newSiloGroupId, prevSiloGroupId)) {
                        vm.siloGroupId = newSiloGroupId;
                        loadSiloGroup();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.siloGroup ? (vm.siloGroup.label || vm.siloGroup.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.silo-group.silo-group-overview') + ': ' + title;
        }
    });

    function loadSiloGroup() {

        if (vm.siloGroupId) {
            vm.loading = true;

            siloGroupService.getSiloGroupSilos(vm.siloGroupId).then(
                (silos) => {
                    silos.forEach((silo) => {
                        if (silo.hasMoistureCables) {
                            vm.hasMoistureData = true;
                        }
                        if (silo.hasCO2Cables) {
                            vm.hasCO2Data = true;
                        }
                    });
                    vm.loading = false;
                },
                () => {
                    vm.loading = false;
                }
            );

            vm.loading = false;
        }
    }
}
